    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                         @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">

                                                
                                                            <el-form-item label="支付方式:">
                                    <el-select v-model="table.where.mode" filterable placeholder="请选择">
                                                                                    <el-option label="微信支付" value="0"></el-option>
                                                                                    <el-option label="余额支付" value="1"></el-option>
                                                                                    <el-option label="次数支付" value="2"></el-option>
                                                                            </el-select>
                                </el-form-item>
                                                                                                        
                                                                                                        
                                                                                                                                        <el-form-item label="分类id:">
                                            <el-select v-model="table.where.class_id" filterable placeholder="请选择">
                                                <el-option v-for="item in chama_class_list" :key="item.id" :label="item.title" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                                                                                                                                                                                                                                
                                                            <el-form-item label="商户订单号:">
                                    <el-input v-model="table.where.out_trade_no" placeholder="请输入商户订单号"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="商户退款单号:">
                                    <el-input v-model="table.where.out_refund_no" placeholder="请输入商户退款单号"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="状态:">
                                    <el-select v-model="table.where.status" filterable placeholder="请选择">
                                                                                    <el-option label=" 待付款" value="1"></el-option>
                                                                                    <el-option label="已支付" value="2"></el-option>
                                                                            </el-select>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="支付金额:">
                                    <el-input-number v-model="table.where.total_price" controls-position="right" :min="0" :controls="false"
                                                     :precision="2" class="ele-fluid ele-text-left" placeholder="请输入支付金额" clearable />
                                </el-form-item>

                                                                                                        
                                                            <el-form-item label="实际支付金额:">
                                    <el-input-number v-model="table.where.total_fee" controls-position="right" :min="0" :controls="false"
                                                     :precision="2" class="ele-fluid ele-text-left" placeholder="请输入实际支付金额" clearable />
                                </el-form-item>

                                                                                                        
                                                            <el-form-item label="总数量:">
                                    <el-input-number v-model="table.where.num" placeholder="请输入总数量" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="创建时间:" >
                                    <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                                                    end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="用户:">
                                    <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                                        <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="支付方式:">
                                    <el-select v-model="table.where.type_payment" filterable placeholder="请选择">
                                                                                    <el-option label="微信" value="1"></el-option>
                                                                                    <el-option label="2=小程序3支付宝" value="23"></el-option>
                                                                            </el-select>
                                </el-form-item>
                                                                                                        
                                                                                                        
                                                                                                                                                                                                                                                                                                            
                                                            <el-form-item label="退款金额:">
                                    <el-input-number v-model="table.where.refund_price" controls-position="right" :min="0" :controls="false"
                                                     :precision="2" class="ele-fluid ele-text-left" placeholder="请输入退款金额" clearable />
                                </el-form-item>

                                                                                                        
                                                            <el-form-item label="退货数量:">
                                    <el-input-number v-model="table.where.refund_num" placeholder="请输入退货数量" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                                </el-form-item>
                                                                                                        
                                                                                                        
                                                            <el-form-item label="姓名:">
                                    <el-input v-model="table.where.name" placeholder="请输入姓名"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="身份证号:">
                                    <el-input v-model="table.where.card" placeholder="请输入身份证号"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="订单号:">
                                    <el-input v-model="table.where.out_pay_num" placeholder="请输入订单号"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="退货单号:">
                                    <el-input v-model="table.where.refund_dh" placeholder="请输入退货单号"  clearable/>
                                </el-form-item>
                                                                                                        
                                                                                                        
                                                                                                        
                                                            <el-form-item label="平台:">
                                    <el-input v-model="table.where.app_plat" placeholder="请输入平台"  clearable/>
                                </el-form-item>
                                                                                                        
                                                                                                                                                                                                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                       class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                                       v-if="permission.includes('sys:chamaorder:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                               class="ele-btn-icon" size="small" >刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:chamaorder:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:chamaorder:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                               @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left"/>
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                                                                                    <el-table-column prop="mode" label="支付方式" show-overflow-tooltip min-width="250" >
                                    <template slot-scope="{row}">
                                                                                    <el-tag v-if="row.mode == 0" :key="index">微信支付</el-tag>
                                                                                    <el-tag v-if="row.mode == 1" :key="index">余额支付</el-tag>
                                                                                    <el-tag v-if="row.mode == 2" :key="index">次数支付</el-tag>
                                                                            </template>
                                </el-table-column>

                                                                                                                                                                                                                                                <el-table-column prop="class_id" label="分类id" show-overflow-tooltip min-width="250" >
                                            <template slot-scope="{row}">
                                                <el-tag v-for="(item,index) in row.class_id_info" :key="index">{{item.title}}</el-tag>
                                            </template>
                                        </el-table-column>
                                                                                                                                        
                                                                                                                
                                    <el-table-column prop="out_trade_no" label="商户订单号" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="out_refund_no" label="商户退款单号" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250" >
                                    <template slot-scope="{row}">
                                                                                    <el-tag v-if="row.status == 1" :key="index"> 待付款</el-tag>
                                                                                    <el-tag v-if="row.status == 2" :key="index">已支付</el-tag>
                                                                            </template>
                                </el-table-column>

                                                                                                                
                                    <el-table-column prop="total_price" label="支付金额" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="total_fee" label="实际支付金额" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="num" label="总数量" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                                                                        <el-table-column prop="user_id" label="用户" show-overflow-tooltip min-width="250" >
                                    <template slot-scope="{row}">
                                        <el-tag v-for="(item,index) in row.user_id_info" :key="index">{{item.nick_name+item.phone}}</el-tag>
                                    </template>
                                </el-table-column>
                                                                                                                <el-table-column prop="type_payment" label="支付方式" show-overflow-tooltip min-width="250" >
                                    <template slot-scope="{row}">
                                                                                    <el-tag v-if="row.type_payment == 1" :key="index">微信</el-tag>
                                                                                    <el-tag v-if="row.type_payment == 23" :key="index">2=小程序3支付宝</el-tag>
                                                                            </template>
                                </el-table-column>

                                                                                                                                                                                                                                                                                                            
                                                                                                                
                                    <el-table-column prop="refund_price" label="退款金额" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="refund_num" label="退货数量" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                                                                        
                                    <el-table-column prop="name" label="姓名" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="card" label="身份证号" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="out_pay_num" label="订单号" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="refund_dh" label="退货单号" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                                                                                                                            
                                    <el-table-column prop="app_plat" label="平台" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                                                                                                                    
                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:chamaorder:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此订单记录吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:chamaorder:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改订单记录':'添加订单记录'" :visible.sync="showEdit"  width="800px" :destroy-on-close="true" :lock-scroll="false" @close="closeDialog"  :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                                                                        
                                                                <el-form-item label="支付方式:" prop="mode">
                                    <el-select v-model="editForm.mode" filterable placeholder="请选择支付方式">
                                                                                    <el-option label="微信支付" value="0"></el-option>
                                                                                    <el-option label="余额支付" value="1"></el-option>
                                                                                    <el-option label="次数支付" value="2"></el-option>
                                                                            </el-select>
                                </el-form-item>

                                                                                                            
                                
                                <el-form-item label="记录信息:" prop="chama_log">
                                    <el-input type="textarea" v-model="editForm.chama_log" placeholder="请输入记录信息" clearable />
                                </el-form-item>
                                                                                                            
                                
                                                                                                            <el-form-item label="分类id:" prop="class_id">
                                            <el-select v-model="editForm.class_id" filterable placeholder="请选择">
                                                <el-option v-for="item in chama_class_list" :key="item.id" :label="item.title" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                                                                                                                                                                                                                                    
                                                                <el-form-item label="商户订单号:" prop="out_trade_no">
                                    <el-input v-model="editForm.out_trade_no" placeholder="请输入商户订单号" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="商户退款单号:" prop="out_refund_no">
                                    <el-input v-model="editForm.out_refund_no" placeholder="请输入商户退款单号" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="状态:" prop="status">
                                    <el-select v-model="editForm.status" filterable placeholder="请选择状态">
                                                                                    <el-option label=" 待付款" value="1"></el-option>
                                                                                    <el-option label="已支付" value="2"></el-option>
                                                                            </el-select>
                                </el-form-item>

                                                                                                            
                                
                                <el-form-item label="支付金额:" prop="total_price">
                                    <el-input-number v-model="editForm.total_price" controls-position="right" :min="0" :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入支付金额" clearable />
                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="实际支付金额:" prop="total_fee">
                                    <el-input-number v-model="editForm.total_fee" controls-position="right" :min="0" :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入实际支付金额" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="总数量:" prop="num">
                                    <el-input-number v-model="editForm.num" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入总数量" clearable />
                                </el-form-item>
                                                                                                            
                                                                                                                
                                
                                <el-form-item label="用户:" prop="user_id">
                                    <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                                        <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone" :value="item.id">
                                        </el-option>
                                    </el-select>

                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="支付方式:" prop="type_payment">
                                    <el-select v-model="editForm.type_payment" filterable placeholder="请选择支付方式">
                                                                                    <el-option label="微信" value="1"></el-option>
                                                                                    <el-option label="2=小程序3支付宝" value="23"></el-option>
                                                                            </el-select>
                                </el-form-item>

                                                                                                            
                                
                                <el-form-item label="备注:" prop="remake">
                                    <el-input type="textarea" v-model="editForm.remake" placeholder="请输入备注" clearable />
                                </el-form-item>
                                                                                                            
                                
                                                                                                                                                                                                                                                                                    
                                
                                <el-form-item label="退款金额:" prop="refund_price">
                                    <el-input-number v-model="editForm.refund_price" controls-position="right" :min="0" :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入退款金额" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="退货数量:" prop="refund_num">
                                    <el-input-number v-model="editForm.refund_num" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入退货数量" clearable />
                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="描述:" prop="description">
                                    <el-input type="textarea" v-model="editForm.description" placeholder="请输入描述" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="姓名:" prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入姓名" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="身份证号:" prop="card">
                                    <el-input v-model="editForm.card" placeholder="请输入身份证号" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="订单号:" prop="out_pay_num">
                                    <el-input v-model="editForm.out_pay_num" placeholder="请输入订单号" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="退货单号:" prop="refund_dh">
                                    <el-input v-model="editForm.refund_dh" placeholder="请输入退货单号" clearable />
                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label=":" prop="info">
                                    <tinymce-editor v-model="editForm.info" :init="initEditor" />
                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="数据信息:" prop="data_info">
                                    <tinymce-editor v-model="editForm.data_info" :init="initEditor" />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="平台:" prop="app_plat">
                                    <el-input v-model="editForm.app_plat" placeholder="请输入平台" clearable />
                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="支付回调数据:" prop="pay_return_info">
                                    <tinymce-editor v-model="editForm.pay_return_info" :init="initEditor" />
                                </el-form-item>
                                                                                                                                                                                                            
                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import { mapGetters } from "vuex";

                                        import TinymceEditor from '@/components/TinymceEditor'
                
        export default {
            name: "SysChamaOrder",
            components: {
                                                                TinymceEditor,
                                            },
            data() {
                return {
                                        table: {
                        url: '/chama/ChamaOrder/index',
                        where: {}                    },  // 表格配置
                    choose: [],  // 表格选中数据
                    showEdit: false,  // 是否显示表单弹窗
                    editForm: {},  // 表单数据
                    editFormTemp:{},
                    admin_list:[],
                    user_list:[],
                    search_show:false,
                                chama_class_list:[],
                                user_openinfo_list:[],
                                    editRules: {  // 表单验证规则
                                                            
                    mode: [
                        {required: true, message: '请选择支付方式', trigger: 'blur'}
                    ],
                    
                                        
                    chama_log: [
                        {required: true, message: '请输入记录信息', trigger: 'blur'}],
                    
                                        
                    class_id: [
                        {required: true, message: '请选择分类id', trigger: 'blur'}
                    ],
                    
                                        
                    out_trade_no: [
                        {required: true, message: '请输入商户订单号', trigger: 'blur'}],
                    
                                        
                    out_refund_no: [
                        {required: true, message: '请输入商户退款单号', trigger: 'blur'}],
                    
                                        
                    status: [
                        {required: true, message: '请选择状态', trigger: 'blur'}
                    ],
                    
                                        
                    total_price: [
                        {required: true, message: '请输入支付金额', trigger: 'blur'}],
                    
                                        
                    total_fee: [
                        {required: true, message: '请输入实际支付金额', trigger: 'blur'}],
                    
                                        
                    num: [
                        {required: true, message: '请输入总数量', trigger: 'blur'}],
                    
                                        
                    create_time: [
                        {required: true, message: '请选择创建时间', trigger: 'blur'}
                    ],
                    
                                        
                    user_id: [
                        {required: true, message: '请选择用户', trigger: 'blur'}
                    ],
                    
                                        
                    type_payment: [
                        {required: true, message: '请选择支付方式', trigger: 'blur'}
                    ],
                    
                                        
                    remake: [
                        {required: true, message: '请输入备注', trigger: 'blur'}],
                    
                                        
                    transaction_id: [
                        {required: true, message: '请选择微信支付订单号	', trigger: 'blur'}
                    ],
                    
                                        
                    refund_price: [
                        {required: true, message: '请输入退款金额', trigger: 'blur'}],
                    
                                        
                    refund_num: [
                        {required: true, message: '请输入退货数量', trigger: 'blur'}],
                    
                                        
                    description: [
                        {required: true, message: '请输入描述', trigger: 'blur'}],
                    
                                        
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}],
                    
                                        
                    card: [
                        {required: true, message: '请输入身份证号', trigger: 'blur'}],
                    
                                        
                    out_pay_num: [
                        {required: true, message: '请输入订单号', trigger: 'blur'}],
                    
                                        
                    refund_dh: [
                        {required: true, message: '请输入退货单号', trigger: 'blur'}],
                    
                                        
                    info: [
                        {required: true, message: '请输入', trigger: 'blur'}],
                    
                                        
                    data_info: [
                        {required: true, message: '请输入数据信息', trigger: 'blur'}],
                    
                                        
                    app_plat: [
                        {required: true, message: '请输入平台', trigger: 'blur'}],
                    
                                        
                    pay_return_info: [
                        {required: true, message: '请输入支付回调数据', trigger: 'blur'}],
                    
                                        
                    title: [
                        {required: true, message: '请输入名称', trigger: 'blur'}],
                    
                                        
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'}],
                    
                                        
                },
            }
            },
            computed: {
                ...mapGetters(["permission"]),
                                initEditor() {
                    return {
                        height: 400,
                        file_picker_callback: this.file_picker_callback,
                        skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                            '/tinymce/skins/ui/oxide',
                        content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' :
                            '/tinymce/skins/content/default/content.css',
                        images_upload_handler: (blobInfo, success, error) => {
                            let file = blobInfo.blob();
                            // 使用axios上传
                            const formData = new FormData();
                            formData.append('file', file, file.name);
                            this.$http.post('/upload/uploadImage', formData).then(res => {
                                if (res.data.code == 0) {
                                    success(res.data.data);
                                } else {
                                    error(res.data.msg);
                                }
                            }).catch(e => {
                                error(e.message);
                            });
                        }
                    };
                }
                            },
            mounted() {

                                this.userAllList();
                                                                this.ChamaClassAllList();                                this.UserOpeninfoAllList();                            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog(){
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/chama/ChamaOrder/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({lock: true});
                            this.$http.post('/chama/ChamaOrder/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({type: 'success', message: res.data.msg});
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) {  // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的订单记录吗?', '提示', {type: 'warning'}).then(() => {
                            const loading = this.$loading({lock: true});
                            this.$http.post('/chama/ChamaOrder/delete', {id: ids}).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({type: 'success', message: res.data.msg});
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else {  // 单个删除
                        const loading = this.$loading({lock: true});
                        this.$http.post('/chama/ChamaOrder/delete', {id:row.id}).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({type: 'success', message: res.data.msg});
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                                /* 获取全部会员 */
                userAllList(){
                    this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.user_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                                                /* 导出数据Excel */
                exportExcel() {
                    let ids  = this.choose.map(d => d.id)
                    if(ids.length == 0){
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/chama/ChamaOrder/exportExcel", {id:ids})
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },
                
                            //查询其他信息
                    ChamaClassAllList(){
            this.$http.post('/chama/ChamaClass/allList', {}).then(res => {
                if (res.data.code === 0) {
                    this.chama_class_list = res.data.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            }).catch(e => {
                this.$message.error(e.message);
            });
        },
                        //查询其他信息
                    UserOpeninfoAllList(){
            this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                if (res.data.code === 0) {
                    this.user_openinfo_list = res.data.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            }).catch(e => {
                this.$message.error(e.message);
            });
        },
        
                }
        }
    </script>

    <style scoped>
        .ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
            width: 100%;
        }
    </style>
